
import { i18nText } from '@/locales';

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {FilterList} from "@/entity/filters/extFilter";
import {Menu, Select, DatePicker, FormModel, Input, Button, Row} from "ant-design-vue";
import {AppStateStore} from "@/store/modules/appState";

@Component({
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu-item": Menu.Item,
    "a-menu": Menu,
    "a-date-picker": DatePicker,
    "a-range-picker": DatePicker.RangePicker,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-input": Input,
    "a-button": Button,
    "a-row": Row,
    "a-input-group": Input.Group,
  },
})

export default class FilterTableComponent extends Vue {
  @Prop({required: true}) readonly filters!: FilterList[]
  @Prop({required: true}) readonly filter_load!: boolean
  @Prop() readonly useCallbackRequest?: boolean

  formData: any = {}
  vModelItems: any = []
  calendarContainersOpen: boolean = false

  substrValue(key: any, k1: any, k2: any) {
    for (let i of this.filters) {
      if (i.key === key) {
        if (k1) this.formData[i.key + 's'] = k1.toString().substr(0, 10)
        if (k2) this.formData[i.key + 'e'] = k2.toString().substr(0, 10)
      }
    }
  }

  @Watch("$store.state.salon_id", {immediate: false})
  resetFormData(): void {
    this.formData = {};
  }

  resetFilter() {
    for (let i of this.filters) {
      i.default_value = [i18nText("Не указано")]
    }
  }

  applyAFilter(): void {
    if(!this.useCallbackRequest) {
      AppStateStore.setApplyFilters(true)
    }
    this.$emit('callback', this.filters);
  }

  clearAFilter(): void {
    this.$emit('clearAFilter');
    this.resetFormData();
    this.resetFilter();
  }

  getPopupContainer(triggerNode: any): any {
    return document.querySelector('main');
  }

  rangeSelectTempale(key1: string, key2: string): string {
    let result: any;

    if (!key1 && !key2) {
      result = i18nText("Не указано")
    } else {
      if (!key1) {
        result = '0' + '/' + key2
      } else if (!key2) {
        result = key1 + '/' + '0'
      } else {
        result = key1 + '/' + key2
      }
    }
    return result;
  }

// Отслеживаем скролл и если открыта сортировка, то скрываем ее при скролле
  beforeMount() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    if (scrollr) {
      scrollr.addEventListener('scroll', this.handleWindowScroll);
    }
  }

  beforeDestroy() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    if (scrollr) {
      scrollr.removeEventListener('scroll', this.handleWindowScroll);
    }
  }

  handleWindowScroll() {
    const elements = document.querySelectorAll('.ant-calendar-picker-container') as NodeListOf<HTMLElement>;

    elements.forEach(element => {
      const existingStyle = element.getAttribute('style');
      if (!existingStyle || !existingStyle.includes('display')) {
        element.style.display = 'none';
      }
    });
  }

  showPicker() {
    console.log("showPicker")
  }
}
